<template>
  <v-main
    id="content"
  >
    <div
      id="core-view"
      :class="$router.currentRoute.name === 'Template' ? 'fill-height' : ''"
    >
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-main>
</template>

<script>
  export default {
    name: 'CoreView',

    metaInfo () {
      return {
      }
    }
  }
</script>
